export const SITE = {
  navHome: "nav-link-home",
  navServices: "nav-link-services",
  navProjects: "nav-link-projects",
  navAbout: "nav-link-about",
  navContact: "nav-link-contact",
  navCtaContact: "nav-cta-contact",
  navMobileToggle: "nav-mobile-toggle",

  heroCta: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  heroTitle: "hero-title",

  serviceCustom: "service-card-custom",
  serviceWaas: "service-card-waas",
  serviceHosting: "service-card-hosting",

  projectsCarousel: "projects-carousel",
  projectSlide: "project-slide",
  projectsPrev: "projects-carousel-prev",
  projectsNext: "projects-carousel-next",

  contactName: "contact-form-name",
  contactEmail: "contact-form-email",
  contactService: "contact-form-service",
  contactMessage: "contact-form-message",
  contactSubmit: "contact-form-submit",
  contactForm: "contact-form",
};
